
/*
    wrapper for the BusOpsPage component for departed trips,
    passes the data context information through to
    facilitate data reloads
*/

import React, {useContext} from "react";

import DataContext from "../DataContext";

import BusOpsPage from "./BusOpsPage";

const BusOpsDepartedPage = (props) => {
    const context = useContext(DataContext);

    console.log("Busops departed context", context);

    return (
        <BusOpsPage mode="DEPARTED" {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
            showExternalChange={context.showExternalChange}
        />
    )
}

export default BusOpsDepartedPage;